import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button, Field, Input } from './ui';
import { AuthLayout } from './auth/AuthLayout';

interface LoginProps {
  onSwitchToSignup: () => void;
}

export function Login({ onSwitchToSignup }: LoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Login failed';
      if (msg === 'PENDING_APPROVAL') {
        setError('Your account is pending admin approval.');
      } else if (msg === 'ACCOUNT_REJECTED' || msg === 'ACCOUNT_REVOKED') {
        setError('Your account access has been revoked.');
      } else if (msg === 'ACCOUNT_SUSPENDED') {
        setError('Your account has been suspended. Contact an administrator.');
      } else if (msg === 'Failed to fetch') {
        setError('Cannot reach the server. Check your connection and try again.');
      } else {
        setError(msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Operations console"
      error={error}
      footer={
        <>
          Don't have an account?{' '}
          <button type="button" className="auth-link" onClick={onSwitchToSignup}>Create an account</button>
        </>
      }
    >
      <form className="auth-form" onSubmit={handleSubmit}>
        <Field label="Email">
          {p => (
            <Input
              {...p}
              type="email"
              autoComplete="username"
              autoFocus
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          )}
        </Field>
        <Field label="Password">
          {p => (
            <Input
              {...p}
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          )}
        </Field>
        <Button type="submit" variant="primary" loading={isLoading}>
          {isLoading ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
    </AuthLayout>
  );
}
